import { M8_UNIT_1 } from './Unit1';
import { M8_UNIT_2 } from './Unit2';
import { M8_UNIT_3 } from './Unit3';
import { M8_UNIT_4 } from './Unit4';
import { M8_UNIT_5 } from './Unit5';
import { M8_UNIT_6 } from './Unit6';
import { M8_UNIT_7 } from './Unit7';
import { M8_UNIT_8 } from './Unit8';
import { M8_UNIT_9 } from './Unit9';
import { M8_UNIT_10 } from './Unit10';
import { M8_UNIT_11 } from './Unit11';
import { M8_UNIT_12 } from './Unit12';
import { M8_UNIT_13 } from './Unit13';
import { M8_READING_PRACTICE } from './ReadingPractice';
import { M8_MODULE_REVIEW } from './UnitReview';


export const MODULE_8_UNITS = [
  M8_UNIT_1,
  M8_UNIT_2,
  M8_UNIT_3,
  M8_UNIT_4,
  M8_UNIT_5,
  M8_UNIT_6,
  M8_UNIT_7,
  M8_UNIT_8,
  M8_UNIT_9,
  M8_UNIT_10,
  M8_UNIT_11,
  M8_UNIT_12,
  M8_UNIT_13,
  M8_READING_PRACTICE,
  M8_MODULE_REVIEW,
];
